import React, { useState, useEffect } from 'react';
import './estilos/AdminPanel.css';
import AdminPanel from './componentes/admin/AdminPanel';
import Login from './componentes/compartidos/Login';
import adminService from './servicios/adminService';

function AdminApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [usuarioActual, setUsuarioActual] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    verificarAutenticacion();
  }, []);

  const verificarAutenticacion = async () => {
    try {
      const token = localStorage.getItem('token');
      
      if (!token) {
        setCargando(false);
        return;
      }

      // Verificar si el usuario es admin/superadmin
      const esAdmin = await adminService.esSuperAdmin();
      
      if (esAdmin) {
        const email = localStorage.getItem('userEmail');
        const nombre = localStorage.getItem('userName') || email?.split('@')[0];
        
        setUsuarioActual({
          email,
          nombre,
          rol: 'admin' // Se confirma desde el backend
        });
        setIsLoggedIn(true);
      } else {
        // No es admin, redirigir
        window.close();
        window.opener?.focus();
      }
    } catch (error) {
      console.error('Error verificando autenticación:', error);
    } finally {
      setCargando(false);
    }
  };

  const handleInicioSesionExitoso = (resultado) => {
    if (resultado.usuario.rol === 'admin' || resultado.usuario.rol === 'superadmin') {
      setUsuarioActual(resultado.usuario);
      setIsLoggedIn(true);
      localStorage.setItem('isLoggedIn', 'true');
    } else {
      alert('Acceso denegado: Solo administradores pueden acceder a este panel');
      window.close();
    }
  };

  const handleCerrarSesion = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userName');
    setIsLoggedIn(false);
    setUsuarioActual(null);
    window.close();
  };

  if (cargando) {
    return (
      <div className="admin-loading">
        <span className="loading-spinner"></span>
        Verificando acceso...
      </div>
    );
  }

  if (!isLoggedIn) {
    return (
      <div className="admin-login-wrapper">
        <div className="admin-login-card">
          <div className="admin-login-icon">SA</div>
          <h1>Panel de Administración</h1>
          <p>Solo administradores autorizados</p>
          <Login alIniciarSesion={handleInicioSesionExitoso} />
        </div>
      </div>
    );
  }

  return (
    <div className="admin-app-wrapper">
      <div className="admin-app-topbar">
        <button
          onClick={() => {
            if (window.opener) {
              window.opener.focus();
            }
            window.close();
          }}
          className="admin-topbar-btn admin-topbar-btn-back"
        >
          ← Volver a la App
        </button>
        <button
          onClick={handleCerrarSesion}
          className="admin-topbar-btn admin-topbar-btn-logout"
        >
          Cerrar Sesión
        </button>
      </div>
      
      <div className="admin-app-body">
        <AdminPanel usuarioActual={usuarioActual} />
      </div>
    </div>
  );
}

export default AdminApp;
